import { render, staticRenderFns } from "./vip-button.vue?vue&type=template&id=6dde4256&scoped=true&lang=pug&"
import script from "./vip-button.vue?vue&type=script&lang=js&"
export * from "./vip-button.vue?vue&type=script&lang=js&"
import style0 from "./vip-button.vue?vue&type=style&index=0&id=6dde4256&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde4256",
  null
  
)

export default component.exports